import React, { useEffect, useRef, createRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getForgeToken } from "../../helpers/actions/RequestData";
import {
  getProjectObject,
  getStaticObject,
  getPendingChecklists,
} from "../../helpers/axios/objectsAxios";
import {
  MODEL_CATEGORIES,
  MODEL_DATA,
  MODEL_LOADED,
  NUMBER_OF_LOADED_MODELS,
  PDF_DATA,
  SELECTED_GUID,
  SELECTED_OBJECT_DATA,
  SELECTED_OBJECT_DATA_LOADING,
  SELECTED_TAG,
  SHOW_ALL,
  SHOW_SELECTION,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";

import {
  AUTH_TIMER,
  PENDING_CHECKLIST_DATA,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import { getAllMaintenance } from "../../helpers/axios/maintenanceAxios";
import {
  getProjectDynamicData,
  getProjectMaintenance,
} from "../../helpers/axios/projectsAxios";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../../helpers/reducers/NavigationReducer";
import properties from "../../../src/assets/images/propertiesBlack.png";
import markupIcon from "../../../src/assets/images/markupIconBlack.png";
import propertiesBlue from "../../../src/assets/images/propertiesBlue.png";
import markupIconBlue from "../../../src/assets/images/markupIconBlue.png";
import viewsBlack from "../../../src/assets/images/views_black.png";
import viewsBlue from "../../../src/assets/images/views_blue.png";
/* global Autodesk, THREE */ // eslint-disable-line

class PdfData {
  constructor(document) {
    this.doc = document;
    this.pages = [];
    this.currentPage = 1;
  }

  parse() {
    const filter = {
      type: "geometry",
      role: "2d",
    };

    const doc = this.doc;
    const rootItem = doc.getRoot();
    const viewables = rootItem.search(filter);

    if (viewables.length === 0) {
      console.error("Document contains no viewables.");
      return false;
    }

    const pages = viewables.map((v) => {
      const files = v.search({ role: "pdf-page" });
      const file = files[0];

      if (!file) return;
      const urn = file.data.urn;

      return {
        guid: v.guid(),
        raw: v,
        name: v.name(),
        urn,
        url: function () {
          return Autodesk.Viewing.endpoint.getItemApi() + urn;
        },
      };
    });

    this.pages = pages;

    if (!pages || pages.length <= 0) return false;

    return true;
  }
}

const ModelViewer = ({
  updateViewerState,
  updateModelNodes,
  updateMarkupExtension,
}) => {
  const { allDocs, selectedProject } = useSelector(
    (state) => state.globalReducer,
  );
  const {
    selectedModels,
    sheetsSelected,
    selectedSheet,
    isPdf,
    geoLocationExt,
    geoToolActive,
    launchViewer,
    modelData,
    modelDataLoaded,
    numberOfLoadedModels,
    selectedDrawingSet,
  } = useSelector((state) => state.modelReducer);
  const { pendingDynamicChanges } = useSelector((state) => state.globalReducer);
  const { selectedIcon } = useSelector((state) => state.navigationReducer);

  const didMount = useRef(false);
  const screenShotRef = createRef(null);

  const [loadingModal, setLoadingModal] = useState(false);
  const [pdfData, setPdfData] = useState();
  const [stateViewerApp, setStateViewerApp] = useState();
  const [urns, setUrns] = useState([]);
  const [selectedDbId, setSelectedDbId] = useState(null);
  const [wipSelected, setWipSelected] = useState(false);
  const [showWipWatermark, setShowWipWatermark] = useState(false);
  const [totalModelsToLoad, setTotalModelsToLoad] = useState(0);
  // const [modelArrayData, setModelArrayData] = useState(null);

  let localModelData = null;

  const dispatch = useDispatch();

  const modelDataRef = useRef(modelData);

  let viewerApp;
  let modelArrayData;
  let viewer;
  let showRedDbIds = [];
  let showRed = true;

  // useEffect(() => {
  //   if (modelDataLoaded) {
  //     // await viewerApp.viewer.unloadExtension("LevelToolExtension");
  //     // viewerApp.viewer.loadExtension("LevelToolExtension").then(() => {});
  //   }
  // }, [modelDataLoaded]);

  useEffect(() => {
    if (selectedDbId) {
      onSuccessGetSelectedTag();
    }
  }, [selectedDbId]);

  useEffect(() => {
    if (launchViewer) {
      launchModelViewer();
    }
    setShowWipWatermark(false);
  }, [launchViewer]);

  useEffect(() => {
    // if (didMount.current) {
    const tempUrns = selectedModels?.map((item) => {
      return {
        urn: item.id,
        xform: { x: 0, y: 0, z: 0 },
      };
    });
    setUrns(tempUrns);
    // } else {
    //   didMount.current = true;
    // }
    isItWip();
  }, [selectedModels]);

  useEffect(() => {
    if (pdfData) {
      markupHandler(0);
    }
  }, [pdfData]);

  const isItWip = () => {
    const tempSelected = selectedModels.map((item) => {
      return item.documentName;
    });
    // const tempAllDocs = [...allDocs];
    //RM TODO - check whether it should be shared revision or publishedrevision
    const filteredDocs = allDocs.filter(
      (o) =>
        tempSelected?.includes(o.docNumber + ".rvt") &&
        o.sharedRevision.includes("."),
    );
    filteredDocs.length === 0 ? setWipSelected(false) : setWipSelected(true);
  };

  const launchModelViewer = () => {
    // if (!urns || urns.length <= 0)
    //   return alert("There are no models with this filter criteria.");

    const updateTimer = (expiry) => {
      dispatch(
        updateGlobalState({
          value: expiry,
          stateName: AUTH_TIMER,
        }),
      );
    };

    const options = {
      env: "AutodeskProduction",
      getAccessToken: (token) => {
        getForgeToken(token, updateTimer);
      },
    };

    const options3d = {
      viewerConfig: {
        wheelSetsPivot: true,
        disableBimWalkInfoIcon: true,
        extensions: [
          "Autodesk.Viewing.MarkupsCore",
          "Autodesk.PDF",
          "Autodesk.Measure",
          "Autodesk.AEC.Minimap3DExtension",
          // "Autodesk.Snapping",
          // "LevelToolExtension",
          // "Autodesk.DocumentBrowser",
          // "Autodesk.Geolocation",
          // "GisToolExtension",
        ],
        disabledExtensions: {
          layermanage: true,
          explode: true,
          bimwalk: true,
          fusionOrbit: true,
          propertiesPanel: true,
        },
      },
    };

    const applyWheelPivotBehavior = () => {
      const activeViewer = viewerApp?.viewer;
      if (!activeViewer) return;

      // AggregatedView can ignore init-time flags, so enforce at runtime.
      activeViewer?.prefs?.set?.("wheelSetsPivot", true);
      activeViewer?.prefs?.set?.("zoomTowardsPivot", true);
      activeViewer?.navigation?.setZoomTowardsPivot?.(true);
    };

    function loadManifest(documentId) {
      return new Promise((resolve, reject) => {
        const onDocumentLoadSuccess = (doc) => {
          onDocumentLoadSuccessActions(doc);
          doc.downloadAecModelData(() => resolve(doc));
        };
        Autodesk.Viewing.Document.load(
          documentId,
          onDocumentLoadSuccess,
          reject,
        );
      });
    }

    Autodesk.Viewing.Initializer(options, function () {
      const getViewerContainer = () => {
        const container =
          screenShotRef?.current || document.getElementById("viewerDiv");

        if (!container || !container.isConnected) {
          return null;
        }

        const rect = container.getBoundingClientRect?.();
        const hasRenderableSize =
          !!rect && Number(rect.width) > 0 && Number(rect.height) > 0;

        return hasRenderableSize ? container : null;
      };

      const initializeViewer = (attempt = 0) => {
        const container = getViewerContainer();

        if (!container) {
          if (attempt < 10) {
            window.setTimeout(() => initializeViewer(attempt + 1), 100);
          }
          return;
        }

        viewer = container;

        // initialize the viewer only when container is mounted and measurable
        viewerApp = new Autodesk.Viewing.AggregatedView();
        viewerApp.init(viewer, options3d);
        applyWheelPivotBehavior();
      const tasks = [];
      urns.forEach((md) => tasks.push(loadManifest("urn:" + md.urn)));
      Promise.all(tasks)
        .then((docs) =>
          Promise.resolve(
            docs.map((doc) => {
              const bubbles = doc.getRoot().search({ type: "geometry" });
              let bubble;
              if (sheetsSelected) {
                bubble = bubbles.find(
                  (o) => o.data.name === selectedSheet.sheetName,
                );
              } else {
                bubble = bubbles[0];
              }
              if (!bubble) return null;
              const modelObject = {
                bubble: bubble,
                urn: doc.myData.guid,
              };
              return modelObject;
            }),
          ),
        )
        .then(async (modelArray) => {
          updateModelNodes(modelArray);

          modelArrayData = modelArray;

          // const bubbles = modelArray.map((model) => {
          //   return model.bubble;
          // });
          // viewerApp.setNodes(bubbles);

          // await viewerApp.waitForLoadDone({
          //   propDb: true,
          //   geometry: true,
          // });
          const bubbles = modelArray.map((model) => {
            return model?.bubble;
          });
          const validBubbles = bubbles.filter(Boolean);

          setTotalModelsToLoad(validBubbles.length);
          dispatch(
            updateModelState({
              value: 0,
              stateName: NUMBER_OF_LOADED_MODELS,
            }),
          );

          if (validBubbles.length === 0) {
            setLoadingModal(false);
            return;
          }

          const loadModel = async () => {
            viewerApp.setNodes(bubbleArray);

            await viewerApp.waitForLoadDone({
              propDb: true,
              geometry: true,
            });
            return;
          };

          const bubbleArray = [];

          setLoadingModal(true);

          for (const bubble of validBubbles) {
            bubbleArray.push(bubble);

            if (
              !(bubbleArray.length % 5) ||
              bubbleArray.length === validBubbles.length
            ) {
              await loadModel();
              dispatch(
                updateModelState({
                  value: bubbleArray.length,
                  stateName: NUMBER_OF_LOADED_MODELS,
                }),
              );
            }
          }
          // viewerApp.viewer.loadExtension("MyCustomExtension");

          viewerApp.viewer
            .loadExtension("Autodesk.Viewing.MarkupsCore")
            .then(function (markupsExt) {
              updateMarkupExtension(markupsExt);
            });

          setLoadingModal(false);

          dispatch(
            updateModelState({
              value: true,
              stateName: MODEL_LOADED,
            }),
          );
          onLoadModelSuccess();
          applyWheelPivotBehavior();
          viewerApp.viewer.addEventListener(
            Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
            onSelect,
          );

          // viewerApp.viewer.container.addEventListener("click", function (ev) {
          //   const result = viewerApp.viewer.clientToWorld(
          //     ev.offsetX,
          //     ev.offsetY
          //   );
          //   if (result) {
          //     var geom = new THREE.SphereGeometry(0.05, 64, 32);
          //     var material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
          //     var sphereMesh = new THREE.Mesh(geom, material);
          //     sphereMesh.position.set(
          //       result.point.x,
          //       result.point.y,
          // result.point.z;
          //     );
          //     if (!viewerApp.viewer.overlays.hasScene("custom-scene")) {
          //       viewerApp.viewer.overlays.addScene("custom-scene");
          //     }
          //     viewerApp.viewer.overlays.addMesh(sphereMesh, "custom-scene");
          //   }
          // });

          var ext = viewerApp.viewer.getExtension("Autodesk.PropertiesManager");
          ext?._toolbarButton?.removeFromParent();
          // const tasks = [];
          //was the code that ripped all the data and put it into state.
          ////////////////////////////////////////////////////////

          const tasks = [];
          const showRedDbIdsTemp = [];
          bubbles.forEach((o) => {
            const model = viewerApp.getModel(o);
            tasks.push(onObjectTreeCreated(model));
          });

          Promise.all(tasks).then(async (values) => {
            //Load All Project Maintenance Records
            const allStaticMaintenance = await getAllMaintenance();
            const allProjectMaintenance = await getProjectMaintenance(
              selectedProject[0].mviewProjectInfo.id,
            );
            const allProjectObjects = await getProjectDynamicData(
              selectedProject[0].mviewProjectInfo.id,
            );

            //Loop over all of the data
            values.forEach((value) => {
              value.data.forEach((item) => {
                //find the project object that matches the guid
                const muid = item.properties.find(
                  (o) => o.displayName === "MUID",
                )?.displayValue;

                //create an array of all possible subsections of the MUID split by the hyphen
                var muidParts = muid?.split("-");
                var muidSubsections = [];
                for (var ii = 0; ii < muidParts?.length; ii++) {
                  muidSubsections.push(muidParts.slice(0, ii + 1).join("-"));
                }

                const projectObject = allProjectObjects.find(
                  (o) => o.guid === item.externalId,
                );
                // debugger;
                //Find all the maintenance that matches the project object id
                const objectMaintenance = allProjectMaintenance.filter(
                  (o) => o.projectObjectId === projectObject?.id,
                );

                //Find any static maintenance that is against the same MUID that is still pending and add it to showRedDbIds
                const staticMaintenance = allStaticMaintenance.filter((o) =>
                  o.keys?.some((k) => muidSubsections.includes(k)),
                );
                staticMaintenance.forEach((maintenance) => {
                  const previousRecords = objectMaintenance.filter(
                    (record) =>
                      record.staticObjectMaintenanceId === maintenance.id,
                  );
                  const lastPerformed = previousRecords.sort(
                    (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
                  )[0];
                  const interval = maintenance.interval;
                  const dimension = maintenance.dimension;
                  let nextDueDate = null;
                  if (lastPerformed) {
                    const lastPerformedDate = new Date(
                      lastPerformed.createdDate,
                    );
                    nextDueDate = new Date(lastPerformedDate);
                    if (dimension === "D") {
                      nextDueDate.setDate(
                        lastPerformedDate.getDate() + interval,
                      );
                    } else if (dimension === "M") {
                      nextDueDate.setMonth(
                        lastPerformedDate.getMonth() + interval,
                      );
                    } else if (dimension === "Y") {
                      nextDueDate.setFullYear(
                        lastPerformedDate.getFullYear() + interval,
                      );
                    } else if (dimension === "H") {
                      nextDueDate.setHours(
                        lastPerformedDate.getHours() + interval,
                      );
                    }
                  }
                  if (nextDueDate == null || nextDueDate < new Date()) {
                    showRedDbIdsTemp.push({
                      dbId: item.dbId,
                      model: value.model,
                    });
                  }
                });
              });
            });
            showRedDbIds = showRedDbIdsTemp;
          });

          //Maintenance Tool Bar
          const button = new Autodesk.Viewing.UI.Button("no-maintenance-btn");
          button.onClick = function (e) {
            if (!viewerApp.viewer || !viewerApp.viewer.model) {
              console.warn("Viewer or model not ready");
              return;
            }

            if (showRed) {
              showRedDbIds.forEach((object) => {
                viewerApp.viewer.setThemingColor(
                  [object.dbId],
                  new THREE.Vector4(1, 0, 0, 1),
                  object.model,
                );
              });
            } else {
              showRedDbIds.forEach((object) => {
                viewerApp.viewer.setThemingColor(
                  [object.dbId],
                  null,
                  object.model,
                );
              });
            }
            showRed = !showRed;
          };
          button.addClass("no-maintenance-btn");
          button.setToolTip("Maintenance Due");
          // button.setIcon("adsk-issues");

          const markupButton = new Autodesk.Viewing.UI.Button("markups");
          const modelObjectButton = new Autodesk.Viewing.UI.Button(
            "modelObjects",
          );
          const viewsButton = new Autodesk.Viewing.UI.Button("views");

          markupButton.icon.style = `background-image: url(${markupIcon}); background-size: 24px 24px;`;
          markupButton.setState(false);
          markupButton.setToolTip("Markups");
          modelObjectButton.icon.style = `background-image: url(${properties}); background-size: 24px 24px;`;
          modelObjectButton.setState(false);
          modelObjectButton.setToolTip("Object Properties");
          viewsButton.icon.style = `background-image: url(${viewsBlack}); background-size: 24px 24px;`;
          viewsButton.setState(false);
          viewsButton.setToolTip("Views");

          markupButton.onClick = function (e) {
            const active = markupButton.getState();
            if (active) {
              markupButton.setState(!active);
              markupButton.removeClass("active");
              markupButton.icon.style = `background-image: url(${markupIcon});background-size: 24px 24px;`;
              if (selectedDrawingSet) {
                dispatch(
                  updateNavigationState({
                    value: "Sheets",
                    stateName: SELECTED_ICON,
                  }),
                );
              } else {
                if (selectedProject[0].projectCode === "legacy") {
                  dispatch(
                    updateNavigationState({
                      value: "Legacy Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                } else {
                  dispatch(
                    updateNavigationState({
                      value: "File Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                }
              }
            } else {
              if (modelObjectButton.getState()) {
                modelObjectButton.setState(!modelObjectButton.getState());
                modelObjectButton.removeClass("active");
                modelObjectButton.icon.style = `background-image: url(${properties});background-size: 24px 24px;`;
              }
              if (viewsButton.getState()) {
                viewsButton.setState(!viewsButton.getState());
                viewsButton.removeClass("active");
                viewsButton.icon.style = `background-image: url(${viewsBlack});background-size: 24px 24px;`;
              }
              markupButton.setState(!active);
              markupButton.addClass("active");
              markupButton.icon.style = `background-image: url(${markupIconBlue});background-size: 24px 24px;`;
              dispatch(
                updateNavigationState({
                  value: "Markup",
                  stateName: SELECTED_ICON,
                }),
              );
            }
          };
          modelObjectButton.onClick = function (e) {
            const active = modelObjectButton.getState();
            if (active) {
              modelObjectButton.setState(!active);
              modelObjectButton.removeClass("active");
              modelObjectButton.icon.style = `background-image: url(${properties});background-size: 24px 24px;`;

              if (selectedDrawingSet) {
                dispatch(
                  updateNavigationState({
                    value: "Sheets",
                    stateName: SELECTED_ICON,
                  }),
                );
              } else {
                if (selectedProject[0].projectCode === "legacy") {
                  dispatch(
                    updateNavigationState({
                      value: "Legacy Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                } else {
                  dispatch(
                    updateNavigationState({
                      value: "File Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                }
              }
            } else {
              if (markupButton.getState()) {
                markupButton.setState(!markupButton.getState());
                markupButton.removeClass("active");
                markupButton.icon.style = `background-image: url(${markupIcon});background-size: 24px 24px;`;
              }
              if (viewsButton.getState()) {
                viewsButton.setState(!viewsButton.getState());
                viewsButton.removeClass("active");
                viewsButton.icon.style = `background-image: url(${viewsBlack});background-size: 24px 24px;`;
              }
              modelObjectButton.setState(!active);
              modelObjectButton.addClass("active");
              modelObjectButton.icon.style = `background-image: url(${propertiesBlue});background-size: 24px 24px;`;
              dispatch(
                updateNavigationState({
                  value: "Properties",
                  stateName: SELECTED_ICON,
                }),
              );
            }
          };

          viewsButton.onClick = function (e) {
            const active = viewsButton.getState();
            if (active) {
              viewsButton.setState(!active);
              viewsButton.removeClass("active");
              viewsButton.icon.style = `background-image: url(${viewsBlack});background-size: 24px 24px;`;

              if (selectedDrawingSet) {
                dispatch(
                  updateNavigationState({
                    value: "Sheets",
                    stateName: SELECTED_ICON,
                  }),
                );
              } else {
                if (selectedProject[0].projectCode === "legacy") {
                  dispatch(
                    updateNavigationState({
                      value: "Legacy Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                } else {
                  dispatch(
                    updateNavigationState({
                      value: "File Browser",
                      stateName: SELECTED_ICON,
                    }),
                  );
                }
              }
            } else {
              if (markupButton.getState()) {
                markupButton.setState(!markupButton.getState());
                markupButton.removeClass("active");
                markupButton.icon.style = `background-image: url(${markupIcon});background-size: 24px 24px;`;
              }
              if (modelObjectButton.getState()) {
                modelObjectButton.setState(!modelObjectButton.getState());
                modelObjectButton.removeClass("active");
                modelObjectButton.icon.style = `background-image: url(${properties});background-size: 24px 24px;`;
              }

              viewsButton.setState(!active);
              viewsButton.addClass("active");
              viewsButton.icon.style = `background-image: url(${viewsBlue});background-size: 24px 24px;`;

              dispatch(
                updateNavigationState({
                  value: "Views",
                  stateName: SELECTED_ICON,
                }),
              );
            }
          };

          // let iconPath = Verified;
          // button.icon.style = `background-image: url(${iconPath}); background-size: 24px 24px;`;
          const group = new Autodesk.Viewing.UI.ControlGroup("my-group");
          // group?.addControl(button);
          group?.addControl(markupButton);
          group?.addControl(modelObjectButton);
          if (!sheetsSelected && selectedProject[0]?.projectCode !== "legacy") {
            group?.addControl(viewsButton);
          }
          viewerApp?.viewer?.toolbar?.addControl(group);

          // modelArray.forEach((o, i) => {
          //   const model = viewerApp.getModel(o.bubble);
          //   tasks.push(onObjectTreeCreated(model, o.urn));
          // });
          // Promise.all(tasks).then((values) => {
          //
          //   const data = [];
          //   values.forEach((value) => {
          //     let property;
          //     value.data.forEach((prop) => {
          //       property = { ...prop, urn: value.urn };
          //       data.push(property);
          //     });
          //   });
          //   getAllProperties(data);
          //   onLoadModelSuccess();
          //   viewerApp.viewer.addEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, onSelect);

          //   //now pass data to onSuccessAddProperties but needs to be changed to account for array of objects rather than 1 object
          // });
          updateViewerState(viewerApp);
        });

      };

      initializeViewer();
    });
  };

  const updatePdfPage = (viewApp, pdf, pageNo) => {
    let options = {
      env: "AutodeskProduction",
      api: "derivativeV2_EU",
      getAccessToken: getForgeToken,
      // refreshToken: getForgeToken,
      PushPinExtensionHandle: null,
    };
    const page = pdf.pages[pageNo - 1];
    const url = page.url();
    // setPdfData(pdf);

    Autodesk.Viewing.Initializer(options, async function () {
      viewApp.start();
      viewApp.setTheme("light-theme");
      viewApp.loadExtension("Autodesk.PDF").then(() => {
        viewApp.loadModel(url);
      });
    });
  };

  const onDocumentLoadSuccessActions = async (doc) => {
    // let viewables = doc.getRoot().getDefaultGeometry();
    viewerApp.viewer.setGroundShadow(false);
    // updateViewerState(viewerApp);

    //---------------------Pdf

    // if (selectedItem.fileType === "pdf") {
    // dispatch(updateModelState(true, IS_PDF));
    //   const pdf = new PdfData(doc);
    //   pdf.parse();
    //   setPdfData(pdf);
    // dispatch(updateModelState(pdf, PDF_DATA));
    //   updatePdfPage(viewerApp, pdf, 1);

    //   // const page = pdf.pages[0];
    //   // const url = page.url();

    //   // Autodesk.Viewing.Initializer(options, async function () {
    //   //   // const viewer = new Autodesk.Viewing.GuiViewer3D(
    //   //   //   document.getElementById(viewerId + "-viewer")
    //   //   // );
    //   //   viewerApp.start();
    //   //   viewerApp.setTheme("light-theme");
    //   //   viewerApp.loadExtension("Autodesk.PDF").then(() => {
    //   //     viewerApp.loadModel(url);
    //   //   });
    //   // });
    // } else {
    // dispatch(updateModelState(false, IS_PDF));
    // }

    //---------------------Pdf

    // if (!viewables.length) {
    //   console.error("Document contains no viewables.");
    //   return;
    // }

    // let initialViewable = viewables[0];
    // setViewable(initialViewable);
    // let svfUrl = doc.getViewablePath(initialViewable);

    // let modelOptions = {
    //   sharedPropertyDbPath: doc.getFullPath(doc.getRoot().findPropertyDbPath()),
    //   isAEC: true,
    // };

    // viewerApp.viewer.addEventListener(
    //   Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
    //   () => {
    //     onLoadModelSuccess();
    //     onObjectTreeCreated();
    //   }
    // );

    // viewerApp.viewer.addEventListener(
    //   Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
    //   onObjectTreeCreated
    // );
  };

  const nextPage = (currentPage) => {
    let tempPdfData = { ...pdfData, currentPage: currentPage + 1 };
    setPdfData(tempPdfData);
    dispatch(
      updateModelState({
        value: tempPdfData,
        stateName: PDF_DATA,
      }),
    );
    updatePdfPage(stateViewerApp, pdfData, currentPage + 1);
  };
  const prevPage = (currentPage) => {
    let tempPdfData = { ...pdfData, currentPage: currentPage - 1 };
    setPdfData(tempPdfData);
    dispatch(
      updateModelState({
        value: tempPdfData,
        stateName: PDF_DATA,
      }),
    );
    updatePdfPage(stateViewerApp, pdfData, currentPage - 1);
  };
  const inputHandler = (e) => {
    let tempPdfData = { ...pdfData, currentPage: e.target.value };
    setPdfData(tempPdfData);
    dispatch(
      updateModelState({
        value: tempPdfData,
        stateName: PDF_DATA,
      }),
    );
    updatePdfPage(stateViewerApp, pdfData, e.target.value);
  };
  const markupHandler = (pageNumber) => {
    let tempPdfData = { ...pdfData, currentPage: pageNumber };
    setPdfData(tempPdfData);
    dispatch(
      updateModelState({
        value: tempPdfData,
        stateName: PDF_DATA,
      }),
    );
    updatePdfPage(stateViewerApp, pdfData, pageNumber);
  };

  const onObjectTreeCreated = async (model) => {
    const instanceTree = model.getData().instanceTree;
    const allDbIdsStr = Object.keys(instanceTree.nodeAccess.dbIdToIndex);
    const allDbIdsInt = allDbIdsStr.map(function (id) {
      return parseInt(id);
    });
    return new Promise((resolve, reject) => {
      model.getBulkProperties2(
        allDbIdsInt,
        { propFilter: ["MUID", "name", "externalId"] },
        //propFilter: ["_RC","MUID", "Tag Number"]
        (data) => {
          resolve({ data, model: model });
        },
        reject,
      );
    });
  };

  const getAllProperties = async (data) => {
    // const catData = data.filter((o) =>
    //   o.properties.some((o) => o.displayName === "_RC")
    // );
    const tempModelData = [];
    const tempPendingChecklistsData = [];

    const tasks = [];
    data.forEach((o, i) => {
      tasks.push(
        onSuccessGetProperties(
          data[i],
          tempModelData,
          tempPendingChecklistsData,
        ),
      );
    });
    Promise.all(tasks).then((values) => {
      var tempUniqueCategories = tempModelData
        .map((o) => o.category)
        .filter((value, index, array) => {
          return array.indexOf(value) === index;
        });

      dispatch(
        updateModelState({
          value: tempModelData,
          stateName: MODEL_DATA,
        }),
      );
      dispatch(
        updateGlobalState({
          value: tempPendingChecklistsData,
          stateName: PENDING_CHECKLIST_DATA,
        }),
      );
      dispatch(
        updateModelState({
          value: tempUniqueCategories,
          stateName: MODEL_CATEGORIES,
        }),
      );
    });
  };

  const onSuccessGetProperties = async (data, tempModelData, urn) => {
    //Ensure a project
    let projectObjectData = null;
    //check if the data contains MUID or Tag Number if so create a project object
    // if (
    //   data.properties.some(
    //     // (o) => o.displayName === "MUID" || o.displayName === "Tag Number",
    //     (o) => o.displayName === "MUID",
    //   )
    // ) {
    //   const tempProjectObject = {
    //     guid: data.externalId,
    //     name: data.name,
    //     projectId: selectedProject[0].mviewProjectInfo.id,
    //     // tag: data.properties.find((o) => o.displayName === "Tag Number")
    //     //   ?.displayValue,
    //   };
    //   projectObjectData = await getProjectObject(tempProjectObject);
    // }
    // Check its an object we care about
    if (data.properties.some((o) => o.displayName === "MUID")) {
      //Load data from model
      const muid = data.properties.find(
        (o) => o.displayName === "MUID",
      )?.displayValue;
      const guid = data.externalId; // This may not be defined as "externalId"
      const name = data.name; // This may not be defined as "externalId"
      const dbId = data.dbId;
      // const tag = data.properties.find(
      //   (o) => o.displayName === "Tag Number",
      // )?.displayValue;
      // Load OPM, Static and Dynamic
      // const objectOpm = await getObject(category);
      const staticObjectData = await getStaticObject(muid);
      if (staticObjectData) {
        const category = staticObjectData?.object?.category;
        const objectGroupingId = staticObjectData?.object?.objectGroupingId;

        // ("Invalid MUID");

        // Loop Over OPM and populate data from DB
        const tempObjectProperties = [];
        staticObjectData?.object?.objectPropertiesMatrices.forEach((opm) => {
          //Check Data Source
          const tempOpm = opm;
          let tempValue = null;
          //Update value depending on what Origin
          switch (tempOpm.objectProperty.origin) {
            case "Static":
              //staticObjectData.objectLibraryProperties
              tempValue = staticObjectData.staticObjectProperties.find(
                (o) =>
                  o.property.toLowerCase() ===
                  opm.objectProperty.property.toLowerCase(),
              )?.value;
              tempOpm.objectProperty.value = tempValue ?? null;
              break;
            // case "Dynamic":
            //   //dynamicObjectData.modelObjectsProperties
            //   //ToDo Rob: I think this needs projectObjectPropertyId added
            //   let tempDynaData =
            //     projectObjectData?.projectObjectProperties?.find(
            //       (o) => o.property === opm.objectProperty.property,
            //     );
            //   if (tempDynaData != null && tempDynaData != undefined) {
            //     tempOpm.objectProperty.value = tempDynaData.value;
            //     tempOpm.projectObjectPropertyId = tempDynaData.id;
            //   }
            //   tempOpm.projectObjectId = projectObjectData.id;
            //   break;
            case "3D":
            case "P&ID":
              //data.properties
              tempValue = data.properties.find(
                (o) => o.displayName === opm.objectProperty.property,
              )?.displayValue;
              tempOpm.objectProperty.value = tempValue ?? null;
              break;
            default:
              break;
          }

          tempObjectProperties.push(tempOpm);
        });

        //Pending checklist on select is currently not required. This may change in the future.
        ////////// TURNED THIS SECTION OFF FOR TIME BEING //////////////
        // const pendingChecklists = await getPendingChecklists(
        //   projectObjectData.id,
        //   muid,
        // );
        // const objectMaintenance =
        //   staticObjectData?.staticObjectMaintenance?.map((maintenance) => {
        //     const previousRecords =
        //       projectObjectData?.projectMaintenance?.filter(
        //         (record) => record.staticObjectMaintenanceId === maintenance.id,
        //       );
        //     const lastPerformed = previousRecords?.sort(
        //       (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
        //     )[0];
        //     const interval = maintenance.interval;
        //     const dimension = maintenance.dimension;
        //     let lastPerformedDate = null;
        //     let nextDueDate = null;
        //     if (lastPerformed) {
        //       lastPerformedDate = new Date(lastPerformed?.createdDate);
        //       nextDueDate = new Date(lastPerformedDate);
        //       if (dimension === "D") {
        //         nextDueDate.setDate(lastPerformedDate?.getDate() + interval);
        //       } else if (dimension === "M") {
        //         nextDueDate.setMonth(lastPerformedDate?.getMonth() + interval);
        //       } else if (dimension === "Y") {
        //         nextDueDate.setFullYear(
        //           lastPerformedDate?.getFullYear() + interval,
        //         );
        //       } else if (dimension === "H") {
        //         nextDueDate.setHours(lastPerformedDate?.getHours() + interval);
        //       }
        //     }
        //     return {
        //       ...maintenance,
        //       records: previousRecords,
        //       lastPerformed: lastPerformedDate,
        //       nextDue: nextDueDate,
        //       projectObjectId: projectObjectData.id,
        //       staticObjectMaintenanceId: maintenance.id,
        //     };
        //   });
        ////////// TURNED THIS SECTION OFF FOR TIME BEING //////////////

        //This doesnt appear to be used in when using the click load on model viewer.
        // for (let index = 0; index < pendingChecklists.length; index++) {
        //   const checklist = pendingChecklists[index];
        //   tempPendingChecklistsData.push({
        //     ...checklist,
        //     projectObjectId: dynamicObjectData.id,
        //     tag,
        //     guid,
        //     category,
        //     properties: tempObjectProperties,
        //   });
        // }
        const result = {
          guid,
          name,
          dbId,
          muid,
          // tag,
          category,
          properties: tempObjectProperties,
          data,
          // projectObjectId: projectObjectData.id,
          // checklists: projectObjectData?.checklistDataLinks,
          // pendingChecklists,
          urn: urn,
          objectGroupingId,
          // maintenance: objectMaintenance,
        };
        tempModelData.push(result);
      } else {
        const result = {
          guid,
          name,
          dbId,
          muid,
          // tag,
          category: "Invalid MUID",
          properties: data.properties,
          data,
          // projectObjectId: projectObjectData?.id,
          // checklists: projectObjectData?.checklistDataLinks,
          // pendingChecklists: [],
          urn: urn,
          objectGroupingId: null,
        };
        tempModelData.push(result);
      }
    } else {
      const result = {
        guid: data.externalId,
        name: data.name,
        dbId: data.dbId,
        muid: null,
        // tag: data.properties.find((o) => o.displayName === "Tag Number")
        //   ?.displayValue,
        category: null,
        properties: data.properties,
        data,
        projectObjectId: null,
        urn: urn,
        objectGroupingId: null,
      };
      tempModelData.push(result);
    }
  };

  const onErrorGetProperties = (dbId) => {
    console.log("Failed to fetch properties");
  };

  const onLoadModelSuccess = async (viewer, item) => {
    if (wipSelected) {
      setShowWipWatermark(true);
    } else {
      setShowWipWatermark(false);
    }

    viewerApp.viewer.getToolbar();
    viewerApp.viewer.setTheme("light-theme");
    viewerApp.viewer
      .loadExtension("Autodesk.Viewing.MarkupsCore")
      .then(function (markupsExt) {
        updateMarkupExtension(markupsExt);
      });

    viewerApp.viewer
      .loadExtension("Autodesk.Measure")
      .then(function (measureExtension) {
        measureExtension.setUnits("mm");
      });
  };

  const onSelect = async () => {
    const viewState = await viewerApp.viewer.getState();
    if (viewState.objectSet.length !== 0) {
      const filteredObjectSet = await viewState.objectSet.filter(
        (o) => o.id.length > 0,
      );
      //seedUrn is the same as model urn
      if (filteredObjectSet.length !== 0) {
        dispatch(
          updateModelState({
            value: true,
            stateName: SELECTED_OBJECT_DATA_LOADING,
          }),
        );
        const selectedObject = {
          id: filteredObjectSet[0]?.id[0],
          urn:
            viewState.objectSet.length === 1
              ? viewState.seedURN
              : filteredObjectSet[0]?.seedUrn,
        };
        let bubbleData = null;
        if (selectedObject.urn === undefined || selectedObject.urn === null) {
          bubbleData = modelArrayData[0];
        } else {
          bubbleData = modelArrayData.find((o) => o.urn === selectedObject.urn);
        }
        const model = viewerApp.getModel(bubbleData.bubble);

        await model.getProperties(
          selectedObject.id,
          (data) => onSuccessGetObjectData(data, selectedObject.urn),
          onErrorGetProperties,
        );
      } else {
        dispatch(
          updateModelState({
            value: null,
            stateName: SELECTED_OBJECT_DATA,
          }),
        );
      }
    }
  };

  const onSuccessGetObjectData = async (data, urn) => {
    const selectedObjectData = [];

    await onSuccessGetProperties(data, selectedObjectData, urn);
    dispatch(
      updateModelState({
        value: selectedObjectData[0],
        stateName: SELECTED_OBJECT_DATA,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: SELECTED_OBJECT_DATA_LOADING,
      }),
    );
  };

  const onSuccessGetSelectedTag = () => {
    if (modelData) {
      const filteredData = modelData.filter(
        (o) =>
          o.data.dbId === selectedDbId.id && o.data.urn === selectedDbId.urn,
      );
      const tag = filteredData[0]?.tag;
      const guid = filteredData[0]?.guid;

      // if (tag === undefined && data.dbId !== undefined) {
      //   var instanceTree = viewerApp.viewer.model.getData().instanceTree;
      //   let parentId = instanceTree.getNodeParentId(data.dbId);
      //   viewerApp.viewer.getProperties(parentId, onSuccessGetSelectedTag, () =>
      //
      //   );
      // }
      dispatch(
        updateModelState({
          value: tag,
          stateName: SELECTED_TAG,
        }),
      );
      dispatch(
        updateModelState({
          value: guid,
          stateName: SELECTED_GUID,
        }),
      );
      dispatch(
        updateModelState({
          value: false,
          stateName: SHOW_ALL,
        }),
      );
      dispatch(
        updateModelState({
          value: true,
          stateName: SHOW_SELECTION,
        }),
      );
    }
  };

  useEffect(() => {
    if (geoToolActive) {
      geoLocationExt.activate();
    } else {
      geoLocationExt?.deactivate();
    }
  }, [geoToolActive, geoLocationExt]);

  const shouldPlaceWipWatermarkRight =
    selectedIcon === "Markup" || selectedIcon === "Views";

  return (
    <>
      {isPdf ? (
        <div className="modal-content">
          <div className="modal-body d-flex align-items-center justify-content-center">
            <div
              className="row d-flex align-items-center justify-content-center "
              style={{ width: "50%" }}
            >
              <div
                className="col-2 d-flex  justify-content-end"
                // style={{ paddingRight: 0 }}
              >
                <p style={{ margin: 0 }}>Page</p>
              </div>
              <div className="col-1 d-flex  justify-content-center">
                <button
                  onClick={(e) => prevPage(pdfData.currentPage)}
                  disabled={pdfData.currentPage === 1}
                >
                  {" "}
                  &lt;
                </button>
              </div>
              <div
                className="col-2 d-flex  justify-content-center"
                style={{ padding: 0 }}
              >
                <input
                  className="form-control form-control-sm pdf-input"
                  type="number"
                  min={1}
                  max={pdfData.pages.length}
                  style={{ width: "100%", WebkitAppearance: "none", margin: 0 }}
                  value={pdfData.currentPage}
                  onChange={inputHandler}
                />
              </div>
              <div className="col-1 d-flex  justify-content-center">
                <button
                  onClick={(e) => nextPage(pdfData.currentPage)}
                  disabled={pdfData.currentPage >= pdfData.pages.length}
                >
                  &gt;
                </button>
              </div>
              <div className="col-2 d-flex justify-content-start">
                <p style={{ margin: 0 }}>
                  of {pdfData ? pdfData.pages.length : null}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <>
        {launchViewer ? (
          <div
            style={{
              position: "relative",
              margin: "2px",
              height: isPdf ? "96%" : "99.75%",
              width: "100%",
            }}
          >
            <div
              className="viewer"
              id="viewerDiv"
              ref={screenShotRef}
              style={{
                position: "relative",
                height: "100%",
                width: "100%",
              }}
            />
            {showWipWatermark && (
              <div
                className={`wipoverlay ${
                  shouldPlaceWipWatermarkRight ? "wipoverlay--right" : "wipoverlay--left"
                }`}
              >
                <h3>WIP - UNCONTROLLED</h3>
              </div>
            )}
          </div>
        ) : (
          window.location.href.includes("viewer") &&
          selectedIcon !== "File Browser" &&
          selectedIcon !== "Sheets" &&
          (selectedProject[0]?.projectCode === "legacy" ? (
            <>
              {/* <div className="centered">
                <h2 style={{ textAlign: "center" }}>
                  Please open a 3D model using the{" "}
                  <a
                    href="#"
                    onClick={() => {
                      dispatch(
                        updateNavigationState({
                          value: "Legacy Browser",
                          stateName: SELECTED_ICON,
                        }),
                      );
                    }}
                  >
                    Model Browser
                  </a>{" "}
                  tab on the left.
                </h2>
              </div> */}
            </>
          ) : (
            <div className="centered">
              <h2 style={{ textAlign: "center" }}>
                Please open a 3D model using the{" "}
                <a
                  href="#"
                  onClick={() => {
                    dispatch(
                      updateNavigationState({
                        value: "File Browser",
                        stateName: SELECTED_ICON,
                      }),
                    );
                  }}
                >
                  Model Browser
                </a>{" "}
                tab on the left.
              </h2>
            </div>
          ))
        )}
      </>
      {/* MODALS */}
      <Modal
        show={loadingModal}
        // onHide={()=> setLoadingModal(false)}
        dialogClassName="loading-modal"
        centered
      >
        {/* <Modal.Header className="bg-dark text-white">
          <Modal.Title>3D Model Loading</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
          
          </div>
        </Modal.Header> */}
        <Modal.Body className="loading-modal__body">
          <div className="row">
            <div className="col">
              <div className="text-center loading-modal__content">
                <h4 className="loading-modal__title">
                  Loading 3D Model...
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="loading-modal__spinner"
                  />
                </h4>
                <p className="loading-modal__copy">
                  Please wait while the model is being loaded. This may take a
                  few moments.
                </p>
                {(() => {
                  const safeTotal = totalModelsToLoad || 0;
                  const safeLoaded = Math.min(numberOfLoadedModels, safeTotal);
                  const progressPct =
                    safeTotal > 0 ? (safeLoaded / safeTotal) * 100 : 0;

                  return (
                    <>
                      <p className="loading-modal__counter">{`${safeLoaded} of ${safeTotal} loaded.`}</p>
                      <div className="progress loading-modal__progress">
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated loading-modal__progress-bar"
                          role="progressbar"
                          aria-valuenow={safeLoaded}
                          aria-valuemin="0"
                          aria-valuemax={safeTotal}
                          style={{
                            width: `${progressPct}%`,
                          }}
                        ></div>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default ModelViewer;
